import { Company } from "@domain/CRM/company";
import { Grower } from "@domain/CRM/grower";
import { Filter, StandardAxiosConfig } from "../../../common";
import { DataAPI_Base, GetAPI_Base, UpdateAPI_Base } from "../base";
import { apiClient } from "../../../client";

class GetAPI_Growers extends GetAPI_Base<Grower> {
	constructor() {
		super("growers", Grower);
	}

	public async byCompany(company: Company, fresh?: boolean): Promise<Grower[]> {
		if (!company.id) return [];
		// due to a oddity in how Airtable FIND works, we need to pass the name of the company, not the ID, even though the value is returned from Airtable as an ID
		// Airtable is just the best -_-
		const filter: Filter<Grower> = { fields: { companyIds: [company.name] } };
		const growers = await super.byFilter(filter, fresh);
		return growers;
	}

	public async withUnreadyJobs(company: Company, fresh?: boolean): Promise<Grower[]> {
		if (!company.id) return [];
		const filterUnready: Filter<Grower> = {
			type: "AND",
			fields: {
				companiesFromJobs: [company.name],
				unreadyJobCount: { operator: ">", value: 0 },
			},
		};
		const growers = await super.byFilter(filterUnready, fresh);
		return growers;
	}
}

class UpdateAPI_Growers extends UpdateAPI_Base<Grower> {
	constructor() {
		super("growers");
	}

	public async phoneNumber(id: string, value: string) {
		const url = `${this.baseUrl}/${id}/phone-number/${value}`;
		await apiClient.post(url, {}, StandardAxiosConfig());
	}
}

export class GrowersAPI extends DataAPI_Base<Grower> {
	get: GetAPI_Growers;
	update: UpdateAPI_Growers;

	constructor() {
		super("growers", Grower);
		this.get = new GetAPI_Growers();
		this.update = new UpdateAPI_Growers();
	}
}
